import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	title: {
		id: 'eoc.escalation-policies.delete-modal.title.no-translate',
		defaultMessage: 'Delete escalation policy?',
		description: 'The text will be displayed in the delete modal title.',
	},
	description: {
		id: 'eoc.escalation-policies.delete-modal.description.no-translate',
		defaultMessage: `This action will permanently remove the escalation policy <strong>{name}</strong> and its rules. This can't be undone.`,
		description: 'The text will be displayed in the delete modal description.',
	},
	cancelButton: {
		id: 'eoc.escalation-policies.delete-modal.cancel-button.no-translate',
		defaultMessage: 'Cancel',
		description: 'The text will be displayed in the delete modal footer for cancel button.',
	},
	deleteButton: {
		id: 'eoc.escalation-policies.delete-modal.delete-button.no-translate',
		defaultMessage: 'Delete',
		description: 'The text will be displayed in the delete modal footer for delete button.',
	},
});
